const formatDisplayCount = (count?: number | null) =>
  typeof count === 'number' && Number.isFinite(count)
    ? count.toLocaleString()
    : '0';

export default formatDisplayCount;
